/**
* =========================================================================================
* Component - Date Picker
* =========================================================================================
* 
**/

import React, { useEffect, useState, useRef } from 'react';
// Packages
import DatePicker from 'react-datepicker'; /* React Datepicker */
import moment from 'moment'; /* Moment */
import { getMobileOperatingSystem, isMobileDevice } from '../common/function';

const UDatePicker = (props) => {
    const datePopupRef = useRef(null);

    const [months, setMonths] = useState(['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']);
    const [years, setYears] = useState([]);

    const [allValues, setAllValues] = useState({
        monthSelected: '',
        yearSelected: '',
        selectMonthDropdownActive: false,
        selectYearDropdownActive: false
    })

    useEffect(() => {
        document.querySelector('.u_layout')?.addEventListener('wheel', handleWheel, { passive: true });

        return () => document.querySelector('.u_layout')?.removeEventListener("wheel", handleWheel);
    }, []);

    // Scroll to selected year
    useEffect(() => {
        const selectScrollTop = document.querySelector('.react-datepicker__year-dropdown .react-datepicker__year-option--selected_year')?.offsetTop;
        if (document.querySelector('.react-datepicker__year-dropdown')) {
            document.querySelector('.react-datepicker__year-dropdown').scrollTop = selectScrollTop;
        }
    }, [allValues]);

    const handleWheel = (e) => {
        if (datePopupRef?.current && !e?.target?.closest('.u_datepicker')) {
            datePopupRef?.current?.setOpen(false);
            closeDropdown();
        }
    }

    // Generate Years
    const getYearsBetweenDates = (startDate, endDate) => {
        let dates = [];
        const start_date = new Date(startDate.setHours(0, 0, 0, 0));
        const end_date = new Date(endDate.setHours(0, 0, 0, 0));

        var years = moment(end_date).diff(start_date, 'years');

        for (var year = 0; year <= years; year++) {
            dates.push(start_date.getFullYear() + year);
        }

        return dates;
    }

    // For the calendar's open month to the min/max range when no date is selected
    const getOpenToDate = () => {
        let date = new Date();
        if (props?.maxDate && date > new Date(props.maxDate)) {
            date = new Date(props.maxDate);
        } else if (props?.minDate && date < new Date(props.minDate)) {
            date = new Date(props.minDate);
        }
        return date;
    }

    // Month Year Header
    const getSelectedDate = date => {
        let c_date = date ? new Date(date) : new Date();
        return c_date?.toLocaleDateString('default', { month: 'long', year: 'numeric' });
    }

    // Month change
    const selectMonth = (month) => {
        setAllValues({ ...allValues, monthSelected: month, selectMonthDropdownActive: false });
    }

    // Active Month dropdown
    const selectMonthDropdown = () => {
        setAllValues({ ...allValues, selectMonthDropdownActive: !allValues.selectMonthDropdownActive, selectYearDropdownActive: false });
    }

    // Year change
    const selectYear = (year) => {
        setAllValues({ ...allValues, yearSelected: year, selectYearDropdownActive: false });
    }

    // Active Year dropdown
    const selectYearDropdown = () => {
        setAllValues({ ...allValues, selectYearDropdownActive: !allValues.selectYearDropdownActive, selectMonthDropdownActive: false });
    }

    // Close dropdown
    const closeDropdown = (e) => {
        setAllValues({ ...allValues, selectMonthDropdownActive: false, selectYearDropdownActive: false })

        if (document.querySelector('.u_settings-left-sidebar .u_content-header')) document.querySelector('.u_settings-left-sidebar .u_content-header').removeAttribute("style");
        props?.onBlur ? props.onBlur(e) : null;
    }

    const setCalendar = (e) => {

        if (datePopupRef.current && isMobileDevice()) {
            datePopupRef.current.setBlur(true)
        }

        if (document.querySelector('.u_settings-left-sidebar .u_content-header') && isMobileDevice() && getMobileOperatingSystem() === 'iOS') {
            document.querySelector('.u_settings-left-sidebar .u_content-header').style.zIndex = 0;
        }

        // Set Years
        let start_year = props?.minDate ? new Date(new Date(props?.minDate).getFullYear().toString()) : new Date((new Date().getFullYear() - 100).toString());
        let end_year = props?.maxDate ? new Date(new Date(props?.maxDate).getFullYear().toString()) : new Date((new Date().getFullYear() + 5).toString());

        setYears(getYearsBetweenDates(start_year, end_year).reverse());

        // Set Month and Year
        let date = e ? new Date(e) : new Date();
        setAllValues({
            ...allValues,
            monthSelected: months[date.getMonth()],
            yearSelected: date.getFullYear(),
        });
    }

    return (
        <div className={`u_datepicker ${props.className}`}>
            <DatePicker {...props} showPopperArrow={false} ref={datePopupRef} autoComplete="off"
                onMonthChange={(e) => setCalendar(e)}
                onYearChange={(e) => setCalendar(e)}
                onBlur={closeDropdown}
                onCalendarClose={closeDropdown}
                // onChangeRaw={handleDateChangeRaw}
                popperProps={{
                    positionFixed: true
                }}
                withPortal={isMobileDevice()}
                {...(isMobileDevice() && {showTimeInput: true,showTimeSelect: false})}
                {...(props?.minMaxDate && !props?.selected && { openToDate: getOpenToDate() })}
                onCalendarOpen={() => setCalendar(props?.selected ? props?.selected : '')}
                renderCustomHeader={({
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled
                }) => (
                    <>
                        {/* Navigation Buttons  */}
                        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} type="button" className="react-datepicker__navigation react-datepicker__navigation--previous" aria-label="Previous Month">Previous Month</button>
                        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} type="button" className="react-datepicker__navigation react-datepicker__navigation--next" aria-label="Next Month">Next Month</button>

                        {/* Selected Month and Year Header */}
                        <div className="react-datepicker__current-month react-datepicker__current-month--hasYearDropdown react-datepicker__current-month--hasMonthDropdown">
                            {getSelectedDate(date)}
                        </div>

                        <div className="react-datepicker__header__dropdown react-datepicker__header__dropdown--scroll">
                            {/* Months */}
                            <div className="react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--scroll">
                                <div className={`react-datepicker__month-dropdown ${allValues.selectMonthDropdownActive ? 'u_block' : 'u_hidden'}`} style={{ maxHeight: '165px', overflow: 'auto' }}>
                                    {
                                        months?.map(month => {
                                            return <div className={`react-datepicker__month-option ${allValues.monthSelected === month ? 'react-datepicker__month-option--selected_month' : ''}`}
                                                key={month}
                                                onClick={() => { changeMonth(months.indexOf(month)), selectMonth(month) }}
                                            >
                                                {month}
                                            </div>
                                        })
                                    }
                                </div>

                                <div className="react-datepicker__month-read-view" onClick={selectMonthDropdown}>
                                    <span className="react-datepicker__month-read-view--down-arrow"></span>
                                    <span className="react-datepicker__month-read-view--selected-month">{months[date.getMonth()]}</span>
                                </div>
                            </div>

                            {/* Years */}
                            <div className="react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--scroll">
                                <div className={`react-datepicker__year-dropdown ${allValues.selectYearDropdownActive ? 'u_block' : 'u_hidden'}`} style={{ maxHeight: '165px', overflow: 'auto' }}>
                                    {
                                        years?.map(year => {
                                            return <div className={`react-datepicker__year-option ${allValues.yearSelected === year ? 'react-datepicker__year-option--selected_year' : ''}`}
                                                key={year}
                                                onClick={() => { changeYear(year), selectYear(year) }}
                                            >
                                                {year}
                                            </div>
                                        })
                                    }
                                </div>

                                <div className="react-datepicker__year-read-view" onClick={selectYearDropdown}>
                                    <span className="react-datepicker__year-read-view--down-arrow"></span>
                                    <span className="react-datepicker__year-read-view--selected-year">{date.getFullYear()}</span>
                                </div>
                            </div>
                        </div>
                    </>
                )}

            />
        </div>
    );
}

export default UDatePicker;